// @ts-ignore
import instance from "../../api/instance";

/**
 * Sends a login OTP to the specified email.
 * @param {string} email - The email address to which the OTP should be sent.
 * @returns {Promise<string>} - A promise that resolves with a success message or throws an error.
 */
const LOGIN_OTP_SUCCESS_MESSAGES = new Set([
  "Login verification code sent successfully",
  "Login OTP sent successfully",
]);

export async function sendLoginOtp(email: string) {
  try {
    const response = await instance.post(
      `${import.meta.env.VITE_FIREBASE_CLOUD_FUNCTIONS}/sendLoginOtp`,
      JSON.stringify({ email }),
      {
        headers: { "Content-Type": "application/json" },
      },
    );

    const serverMessage =
      typeof response.data?.message === "string" ? response.data.message : "";
    if (LOGIN_OTP_SUCCESS_MESSAGES.has(serverMessage)) {
      return "Verification code has been sent to your email successfully.";
    }
    const okHttp =
      response.status >= 200 &&
      response.status < 300 &&
      response.data?.error == null &&
      response.data?.errors == null;
    if (okHttp) {
      return "Verification code has been sent to your email successfully.";
    }
    throw new Error(
      serverMessage || "Unable to send verification code. Please try again.",
    );
  } catch (error: any) {
    // Improved error handling to capture various error formats
    let errorMessage = "Failed to send verification code.";

    if (error?.response) {
      // Check multiple possible error message locations
      errorMessage =
        error.response.data?.error ||
        error.response.data?.message ||
        error.response.data?.detail ||
        error.response.data?.error_message ||
        (typeof error.response.data === "string"
          ? error.response.data
          : null) ||
        `Server error: ${error.response.status} ${error.response.statusText}`;
    } else if (error?.message) {
      errorMessage = error.message;
    } else if (typeof error === "string") {
      errorMessage = error;
    }

    // Log the full error for debugging
    console.error("sendLoginOtp error:", {
      error,
      response: error?.response?.data,
      status: error?.response?.status,
      statusText: error?.response?.statusText,
    });

    throw new Error(errorMessage);
  }
}
